export const currency = {
	format: amount => (
		parseInt( amount ) === parseFloat( amount )
			? `€${parseInt( amount )}`
			: `€${parseFloat( amount ).toFixed( 2 ).replace( '.', ',' )}`
	),
	code: 'EUR',
}
